import styled from "styled-components";

export const PromotionBannerContainer = styled.div`
	--color1: rgb(175 175 175 / 64%);
	--color2: rgb(250 250 250 / 59%);
	margin-bottom: 20px;
	overflow-x: clip;
	padding-top: ${window.HAS_CASINO_TABS ? "90px" : "20px"};
	.swiper-wrapper .swiper-slide {
		border-radius: 15px;
		overflow: hidden;
		transform: translateZ(0);
		backface-visibility: hidden;
		display: inline-flex;
		cursor: pointer;
		box-shadow: var(--bonus-slider-shadow);

		width: ${({ count }) => (count === 3 ? 428 : 282)}px;

		@media (min-width: 1600px) {
			width: ${({ count }) => (count === 3 ? 530 : 350)}px;
		}

		&:before {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			background-repeat: no-repeat;
			opacity: 0.5;
			mix-blend-mode: color-dodge;
			transition: all 0.33s ease;
			background-position: 50% 50%;
			background-size: 300% 300%;

			background-image: linear-gradient(
				120deg,
				transparent 0%,
				var(--color1) 48%,
				transparent 47%,
				transparent 53%,
				var(--color2) 75%,
				transparent 100%
			);
			opacity: 0.5;
			filter: brightness(0.5) contrast(1);
			z-index: 1;
		}
		&:hover:before {
			content: "";
			animation: none;
			background-image: linear-gradient(
				110deg,
				transparent 25%,
				var(--color1) 48%,
				var(--color2) 52%,
				#4e4e4e 75%
			);
			background-position: 50% 50%;
			background-size: 250% 250%;
			opacity: 0.88;
			filter: brightness(0.66) contrast(1.33);
			transition: none;
		}
	}

	.swiper-wrapper img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;
